<div class="row mb-4">
    <div class="col-sm-12 mx-auto">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <h4 class="card-title col-12 mb-4">Edit Quiz Info</h4>
                    <div class="text-center" *ngIf="!formGroup?.controls?.id">
                        <div class="spinner-grow" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <form *ngIf="formGroup?.controls?.id" #theForm="ngForm" (ngSubmit)="submitForm(formGroup)" novalidate class="col-12">
                        <div [formGroup]="formGroup">
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Name</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" [value]="formGroup.get('info_name')?.value" class="form-control" readonly>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Info</label>
                                </div>
                                <div class="col-md-8">
                                    <textarea rows="5" formControlName="info" [class.is-invalid]="formGroup.get('info')?.invalid && (theForm.submitted || formGroup.get('info')?.touched)" placeholder="Type information" class="form-control" required></textarea>
                                    <div class="text-danger text-end w-100" *ngIf="formGroup.get('info')?.invalid && (theForm.submitted || formGroup.get('info')?.touched)">
                                        <small *ngIf="formGroup.get('info')?.errors?.required">Type info</small>
                                        <small *ngIf="formGroup.get('info')?.errors?.serverError">{{formGroup.get('info')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center border-top pt-4 mt-4">
                            <div>
                                &nbsp;
                            </div>
                            <div class="text-end">
                                <button type="button" class="btn btn-secondary" (click)="back();" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">close</i> &nbsp;
                                    Cancel
                                </button>
                                &nbsp;
                                <button type="submit" class="btn btn-primary" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">save</i> &nbsp;
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
